<template>
    <!-- XX详情 -->
    <div class="rzy-page">
        <div class="rzy-top-bar">
            <el-button type="primary" @click="refreshPage()" style="" size="mini" icon="el-icon-refresh">刷新</el-button>

            <el-button type="primary" @click="previousRecord()" style="" size="mini" icon="el-icon-arrow-up">上一条
            </el-button>
            <el-button type="primary" @click="nextRecord()" style="" size="mini" icon="el-icon-arrow-down">下一条
            </el-button>

            <el-button type="primary" @click="initPrint('pageDetail')" size="mini" icon="el-icon-printer">打印
            </el-button>

            <el-button v-if="$store.state.role.role.includes('shiporder.edit')" type="success" @click="editShipmentOrder()" size="mini" icon="el-icon-edit">编辑</el-button>
        </div>

        <div id="pageDetail" style="float:left;">
			<br />
			<div class="wuliaoDetail" style="display:flex;">
				<div style="display: flex;">
					<el-descriptions border size="medium" column="2" style="width: 800px;">
						<el-descriptions-item label="单据日期">{{shipmentInfo.createTime}}</el-descriptions-item>
						<el-descriptions-item label="单据编号">{{shipmentInfo.shipNumber}}</el-descriptions-item>
						<el-descriptions-item label="出货员" :labelStyle='labelStyleKey' >{{shipmentInfo.contact}}</el-descriptions-item>
						<el-descriptions-item label="客户名称">{{shipmentInfo.customer}}</el-descriptions-item>
						<el-descriptions-item label="地址">{{shipmentInfo.address}}</el-descriptions-item>
						<el-descriptions-item label="备注">{{shipmentInfo.remark}}</el-descriptions-item>
						<!-- 占位用，别删除 -->
						<!-- <el-descriptions-item label="">{{warehouseInfo.XXXX}}</el-descriptions-item> -->

					</el-descriptions>
					</div>
					<div style="display: flex; justify-content: center; ">
						<div style="display: flex; flex-direction: column;  ">
							<div id="qrCodeUrl"></div>
						</div>
					</div>
				
            </div>

			<div>		
				<el-row :gutter="10" style="margin-top:10px">
					<el-col :lg="24" :md="24" :sm="24">
						<div class="col-header">计划出货清单</div>
						<el-table :data="shipmentInfo.items" :row-style="{height: '0'}" :cell-style="{'padding':'0px'}"
							:header-cell-style="{padding: 0}" border>
							<el-table-column label="行" type="index" :index="indexMethod">
							</el-table-column>
							<el-table-column v-for="(obj,key,index) in materialItemsKeys" :key="index" :label="obj.value"
								 :prop="key" align="center" />
						</el-table>
					</el-col>
				</el-row>
			</div>
			<div>			
				<el-row :gutter="10" style="margin-top:10px" class="wuliaoPanels">
					<el-col :lg="24" :md="24" :sm="24">
						<div class="col-header">实际出货清单</div>	
						<el-table 
							:data="shipmentInfo.outItems" 
							:row-style="{height: '0'}" 
							:cell-style="{'padding':'0px', 'padding-left':'10px'}"
							:header-cell-style="{padding: 0,'padding-left':'10px'}"
							:span-method="arraySpanMethod"
							border >
							
							<el-table-column v-for="(obj,key,index) in stockItemsKeys" :key="index" :label="obj.value"
								 :prop="key" :align="obj.align" />
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
			</div>

        </div>
    </div>
</template>

<script>
    import QRCode from 'qrcodejs2' //二维码生成
    import printJS from 'print-js'
	
    export default {
        data() {
            return {
                shipmentInfo: {
                    
                },
				labelStyleKey:   { 'width': '90px' },

                //物料信息
                materialItemsKeys: {

                    materialNumber: {
                        value: '物料编号',
                        width: 150
                    },
                    materialName: {
                        value: '物料名称',
                        width: 150
                    },

                    count: {
                        value: '计划出货(千克)',
                        width: 150
                    },
                },

                //实际出库信息
                stockItemsKeys: {
                    id: {
                        value: 'ID',
                        width: 180
                    },

                    juanbuNumber: {
                        value: '落布标签',
                        width: 200
                    },

                    productName: {
                        value: '产品名称',
                        width: 150
                    },
					
					juanbuCount: {
						value: '匹数',
						width: 100
					},

                    productLength_change: {
                        value: '米数',
                        width: 100
                    },

                    productWeight_change: {
                        value: '过磅重量(千克)',
                        width: 130
                    },
                },
                lastShipmentId: 0, // 上一条/下一条 切换后，记录最新的ID
            }
        },
        methods: {
			// 合并合计第一行
			arraySpanMethod({ row, column, rowIndex, columnIndex }) {
				// console.log(row, column, rowIndex, columnIndex)
				if (rowIndex === 0) {
					if (columnIndex === 0) { //合并前4列
						return {
							rowspan: 1,
							colspan: 3
						};
					}else if(columnIndex < 3 ) {//用来占位
						return {
							rowspan: 0,
							colspan: 0
						}
					}
			    }
			},
            // 根据ID，获取信息
            getShipmentInfo(shipmentId) {
                this.$requestBase({
                    url: 'v1/ship/order/detail',
                    method: 'get',
                    params: {
                        id: shipmentId
                    }
                }).then(res => {
                    res = res.data
                    this.shipmentInfo = res
                    this.formatResponse()
                    
                    this.qrCodeGeneration() //二维码生成
                })
            },

            //格式化 返回结果
            formatResponse() {
                //对某些字段 做 显示变换。
				let realitySlabWeight = 0 //总重量
				let realitySlabMeter = 0 //总米数
				let realityCount = 0 //总匹数
                this.shipmentInfo.createTime = this.utils.timestampToTime(this.shipmentInfo.createTime, 2)

                //hcy: 数量和之前原料是一样的处理，后端传递过来，前端需要转换下。
                for (let i = 0; i < this.shipmentInfo.items.length; i++) {
                    this.shipmentInfo.items[i].count = (this.shipmentInfo.items[i].count / 100).toFixed(2) //数量
                    this.shipmentInfo.items[i].totalWeight_change = (this.shipmentInfo.items[i].totalWeight / 1000).toFixed(2) //库存
                }
                //实际出库清单
                for (let i = 0; i < this.shipmentInfo.outItems.length; i++) {
                    //米数：要从厘米 变成 米。
                    this.shipmentInfo.outItems[i].productLength_change =
                        (this.shipmentInfo.outItems[i].productLength / 100).toFixed(2)
                    
                    //过磅重量数值单位现在为克，应该转为千克。 
                    this.shipmentInfo.outItems[i].productWeight_change =
                        (this.shipmentInfo.outItems[i].productWeight / 1000).toFixed(2)
						
					realitySlabMeter += Number(this.shipmentInfo.outItems[i].productLength)
					realitySlabWeight += Number(this.shipmentInfo.outItems[i].productWeight)
					realityCount += Number(this.shipmentInfo.outItems[i].juanbuCount)
                }
				
				let obj = {
					id: '合计（汇总）',
					productLength_change: (realitySlabMeter / 100).toFixed(2),
					productWeight_change: (realitySlabWeight / 1000).toFixed(2),
					juanbuCount: realityCount
				}
				// 插入合计的数据
				this.shipmentInfo.outItems.unshift(obj);
				
            },


            // 在打印当前报表前，拼接title
            initPrint(id) {
                // this.utils.printTable(id, `出库单详情`)
                printJS({
                	// printable: 'pageDetail', type: 'html', targetStyles: ['*'], maxWidth: 1100, scanStyles: true
                	printable: id, 
                	type: 'html', 
                	targetStyles: ['*'], 
                	maxWidth: 1100, 
                	scanStyles: true,
                	header: '出货单详情',
                	           // style: `@page {size:auto;margin-top:100px; margin-left:15px; margin-right: 15px;}
                	           //  thead th {
                	           //    border-top: 2px solid #000;
                	           //    border-right: 2px solid #000;
                	           //    border-left: 2px solid #000;
                	           //  }
                	           //  tbody td {
                	           //    border: 2px solid #000;
                	           //  }
                	           //  tbody {
                	           //    text-align: center;
                	           //  }
                	           //  table {
                	           //    border-collapse: collapse;
                	           //  }`,					
                })
            },
            // 刷新
            refreshPage() {
                this.getShipmentInfo(this.lastShipmentId)
                this.avoidMultiPop('刷新成功。')
            },
            // 上一条记录
            previousRecord() {
                this.$requestBase({
                    url: 'v1/ship/order/prev',
                    method: 'get',
                    params: {
                        id: this.lastShipmentId,
                    }
                }).then(res => {
                    res = res.data

                    if (res != undefined) {
                        this.shipmentInfo = res
                        this.formatResponse()

                        this.lastShipmentId = res.id //更新工单ID
						this.qrCodeGeneration() //二维码生成
                        this.avoidMultiPop('切换上一条记录成功。')
                    } else { // null 表示数据库 到顶 或者 到底。
                        this.avoidMultiPop('没有更多数据。')
                    }
                })
            },
            // 下一条记录
            nextRecord() {
                this.$requestBase({
                    url: 'v1/ship/order/next',
                    method: 'get',
                    params: {
                        id: this.lastShipmentId,
                    }
                }).then(res => {
                    res = res.data

                    if (res != undefined) {
                        this.shipmentInfo = res
                        this.formatResponse()

                        this.lastShipmentId = res.id //更新工单ID
						this.qrCodeGeneration() //二维码生成
                        this.avoidMultiPop('切换下一条记录成功。')
                    } else { // null 表示数据库 到顶 或者 到底。
                        this.avoidMultiPop('没有更多数据。')
                    }
                })
            },
            //避免重复弹窗
            avoidMultiPop(message) {
                this.$Message.closeAll()
                this.$Message.success(message)
            },

            // 编辑胚布档案
            editShipmentOrder() {
                this.$router.push({
                    path: `../shipmentOrderAdd`,
                    query: {
                        type: 1, //0=新建, 1=编辑.
                        //上一条/下一条切换 后 点 编辑，要找最新的id -- sta
                        // warehouseId: this.$route.params.id,
                        shipmentId: this.lastShipmentId,
                        //上一条/下一条切换 后 点 编辑，要找最新的id -- end
                    }
                })
            },

            //给 所有 表格 自动 加行号
            indexMethod(index) {
                return index + 1;
            },

            // 二维码生成
			qrCodeGeneration() {
                // 生成二维码
                this.$nextTick(function () {
                    document.getElementById("qrCodeUrl").innerHTML = "";
                    let qrCodeUrl= new QRCode("qrCodeUrl", {
                        width: 130,
                        height: 130,
                        text: this.shipmentInfo.shipNumber, //单据编号
                        colorDark: "#409EFF",
                        colorLight: "#fff"
                    });
                });
            },

        },
        created() {
            this.getShipmentInfo(this.$route.params.id)

            this.lastShipmentId = this.$route.params.id //初始化时候 备份 出货单ID.
        }
    }
</script>

<style lang='scss' scoped>
</style>
